import "./MDLTeam.scss";

import MDLPersons from "../../ui/MDLPersons/MDLPersons";
import { Person } from "../../ui/MDLPersons/person";

const MDLTeam = () => {
  const persons: Person[] = [
    {imgPath: 'ruth_avatar.jpg', firstName: 'Ruth Angelica', title: 'S.Pd.', lastName: 'Harestina', role: 'Sekretärin', email: 'ruthhrstna@gmail.com'}, 
    {imgPath: 'intan_avatar.jpg', firstName: 'Intan', title: 'S.Pd.', lastName: 'Hutahaean', role: 'Vorsitzende', email: 'Intansworld@gmail.com'},
    {imgPath: 'margaretha_avatar.jpg', firstName: 'Margaretha Agapia', title: 'Dr.', lastName: 'Sailer', role: 'Schatzmeisterin', email: 'margaretha.agapia@gmail.com'}
  ];

  return (
    <div id="mdl-team">
      <MDLPersons persons={persons}></MDLPersons>
      <div>
        <h2 id="mdl-team-members-caption">Unsere Mitglieder</h2>
        <div id="mdl-team-image-container">
          <img src="mdl2025weihnachtsfeier.png" alt="Team Image"></img>
        </div>
        
      </div>
    </div>
  );
};

export default MDLTeam;
